<microsec-card [isBordered]="true">
  <div class="grid grid-cols-12 gap-4">
    <!-- Left Nav -->
    <div class="col-span-12 md:col-span-6 lg:col-span-3 border-r border-grey pr-6">
      @for (option of options(); track $index) {
        <div
          class="flex flex-col w-full py-2 select-none"
          [ngClass]="{
            'font-bold text-highlight': selection().value === option.value,
            'cursor-pointer text-gray-500': selection().value !== option.value
          }"
          (click)="selection.set(option)">
          {{ option.label }}
        </div>
      }
    </div>
    <!-- Content -->
    <div class="col-span-12 md:col-span-6 lg:col-span-9 col px-6">
      <div class="flex flex-col gap-4 w-full">
        <div class="font-bold text-xl">{{ selection().label }}</div>
        <div class="text-gray-500">{{ selection().desc }}</div>
        <p-divider styleClass="my-1" />
        <p-button
          severity="primary"
          [style]="{ 'text-transform': 'none' }"
          [rounded]="true"
          [label]="selection().buttonText"
          (onClick)="openLink()" />
      </div>
    </div>
  </div>
</microsec-card>
